import React from "react";
import "./hexagon-button.scss";

export default function HexagonButton({ children, className = "", ...props }) {
  return (
    <button className={`hexagon-button ${className}`} {...props}>
      {children}
    </button>
  );
}
